;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import SvgIcon from "@mui/material/SvgIcon"
import svg from "../assets/NumberOfSessions.svg"

function NumberOfSessionsIcon() {
  return (
    <SvgIcon
      component={svg}
      viewBox="0 0 26 24"
      sx={{
        width: "26px",
        height: "24px",
      }}
    />
  )
}
export default NumberOfSessionsIcon
